import { Injectable } from '@angular/core';
import { ConfirmationService } from 'primeng/api';

@Injectable()
export class ConfirmModalService {
  private modals: any[] = [];

  constructor(private confirmationSvc: ConfirmationService) {
  }

  public confirmDiscard(): Promise<boolean> {
    const message = 'Do you want to discard your changes?';
    return this.confirmDialog(message, 'Warning');
  }

  public confirmDelete(): Promise<boolean> {
    const message = 'Are you sure you want to delete?';
    return this.confirmDialog(message, 'Warning');
  }

  public confirmCustom(message: string, header: string): Promise<boolean> {
    return this.confirmDialog(message, header);
  }

  public confirmDialog(theMessage: string,
                       theHeader: string,
                       theAcceptLabel: string = 'Yes',
                       theRejectLabel: string = 'No',
                       showReject: boolean = true,
                       theIcon: any = null): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.confirmationSvc.confirm({
        header: theHeader,
        icon: theIcon,
        message: theMessage,
        acceptLabel: theAcceptLabel,
        acceptVisible: true,
        rejectLabel: theRejectLabel,
        rejectVisible: showReject,
        accept: () => {
          resolve(true);
        },
        reject: () => {
          resolve(false);
        }
      });

      // This is a patch for the issue of the prime dialog component
      // Known issue: the prime dialog or confirm dialog doesn't display responsively
      // (modal not centered display) for smaller resolution.
      // So we need to dispatch resize event to trigger the responsive display of the prime dialog.
      setTimeout(() => {
        const resizeEvent = window.document.createEvent('UIEvents');
        resizeEvent.initUIEvent('resize', true, false, window, 0);
        window.dispatchEvent(resizeEvent);
      });
    });
  }
}
